const oevb = {
  siegel: [],
  produktvergleich: {
    links: {
      leistungsuebersichtLink: 'https://www.oevb.de/hausrat_leistungsuebersicht',
      infoBlattLink: 'https://www.oevb.de/hausrat_produktinformation',
      infoBlattGlasLink: 'https://www.oevb.de/haushalt_glas_produktinformation',
      versBedingungenLink: 'https://www.oevb.de/hausrat_versicherungsbedingungen',
      versBedingungenGlasLink: 'https://www.oevb.de/haushalt_glas_versicherungsbedingungen',
    },
  },
  footertext: `<h2 class="h5">Beitragsberechnung zur Hausratversicherung</h2>
    <p>Mit dem <strong>Beitragsrechner zur Hausratversicherung der ÖVB berechnen Sie in wenigen Sekunden, was die Versicherung für Ihren Hausrat kostet.</strong> 
    Nach der Beantwortung weniger Fragen erfahren Sie sofort die Versicherungskosten und können direkt online abschließen.</p>
    <p>Die Hausratversicherung der <strong>ÖVB</strong> ist die richtige Wahl für alle, die ihren "Wohnungsinhalt" oder die Einrichtung Ihres Hauses in Bremen und Bremerhaven absichern wollen. 
    Mit unserer langjährigen Erfahrung wissen wir, worauf es ankommt. Ihr Hausrat ist bei uns in den besten Händen. 
    Mit den starken Leistungen der ÖVB Hausratversicherung ist Ihr Hab und Gut bestens geschützt.</p>
    <p>Mit unseren Zusatzbausteinen können Sie den Versicherungsschutz individuell gestalten und zum Beispiel Schutz vor Naturgefahren (Elementarschäden) einschließen.</p>
    <p>Profitieren Sie von starken Leistungen: Wir leisten bei Schäden für die Reparatur oder Neuanschaffung einschließlich Preissteigerungen und Folgekosten. 
    Mit der Außenversicherung sind Ihre Sachen auf Reisen versichert. Auf Wunsch sind zudem Schäden durch grobe Fahrlässigkeit oder der Diebstahl in Schule oder am Arbeitsplatz eingeschlossen.</p>`,
};

export default oevb;
